/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Event Category enum values.
 */
export enum ITKSECEventCategories {
    User_Created = 610100,
    /**
     * User Entity master data.
     */
    User_MasterDataChanged = 610200,
    User_Permissions = 610300,
    User_Locked = 610400,
    User_Deleted = 610500,
}
